var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "12px",
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "WS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 0,
    y: 0,
    width: 16,
    height: 11.4285714,
    rx: 1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20934F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#197940",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#262626",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D0D0D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E62539",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA1A2C",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WS"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "FlagBackground",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "url(#linearGradient-4)",
    fillRule: "nonzero",
    mask: "url(#mask-3)",
    x: 0,
    y: 7.61904762,
    width: 16,
    height: 3.80952381
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "url(#linearGradient-5)",
    fillRule: "nonzero",
    mask: "url(#mask-3)",
    x: 0,
    y: 0,
    width: 16,
    height: 3.80952381
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "url(#linearGradient-6)",
    fillRule: "nonzero",
    mask: "url(#mask-3)",
    x: 0,
    y: 3.80952381,
    width: 16,
    height: 3.80952381
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4521879,4.57844615 C10.3153531,4.52772528 10.1672423,4.5 10.0126151,4.5 C9.31790472,4.5 8.75473067,5.05964407 8.75473067,5.75 C8.75473067,6.44035593 9.31790472,7 10.0126151,7 C10.1672423,7 10.3153531,6.97227472 10.4521879,6.92155385 C10.1938742,7.12708334 9.86611267,7.25 9.50946134,7.25 C8.67580886,7.25 8,6.57842713 8,5.75 C8,4.92157287 8.67580886,4.25 9.50946134,4.25 C9.86611267,4.25 10.1938742,4.37291666 10.4521879,4.57844615 Z M11.0189227,6.15999999 L10.5823022,6.65096887 L10.6963499,6.00563081 L10.0378454,5.97252094 L10.616681,5.65876642 L10.2321597,5.1265102 L10.8399083,5.38060276 L11.0189227,4.75 L11.1979371,5.38060276 L11.8056856,5.1265102 L11.4211644,5.65876642 L12,5.97252094 L11.3414955,6.00563081 L11.4555432,6.65096887 L11.0189227,6.15999999 Z",
    id: "Oval-12",
    fill: "#D81F32",
    fillRule: "nonzero",
    mask: "url(#mask-3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-83",
    fill: "url(#linearGradient-7)",
    fillRule: "nonzero",
    mask: "url(#mask-3)",
    points: "0 0 6.08021321 5.70048443 0 11.4285714"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEh);
export default __webpack_public_path__ + "static/media/EH.c73be32cc6b56618da8466fdb75a08e0.svg";
export { ForwardRef as ReactComponent };